import { render, staticRenderFns } from "./MatchHeadstart.vue?vue&type=template&id=d7d416ba&"
import script from "./MatchHeadstart.vue?vue&type=script&lang=ts&"
export * from "./MatchHeadstart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports